// src/pages/categories/CategoryScreen.tsx

import React from "react";
import { useTheme } from "../../common/hooks/useTheme";
import { ProductHeader } from "../../common/components/productHeader/ProductHeader";
import { PageMeta } from "../../common/components/pageMeta/PageMeta";
import styles from "./CategoryScreen.module.scss";
import CategoryTileList from "./components/categoryTileList/CategoryTileList";

const CategoryScreen = () => {
  const { theme } = useTheme();

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      <PageMeta />

      <ProductHeader
        title="Категории"
        isFavorite={false}
        showFavorite={false}
        textColor={theme.text}
        borderColor={theme.border}
        // backgroundColor={theme.background}
      />

      <CategoryTileList />
    </div>
  );
};

export default CategoryScreen;
